<template>
  <b-row>
    <b-col cols="12">
      <b-form-group label="Poznámka:" class="my-2" label-for="inputNote">
        <b-form-textarea
          v-model="peopleSelectionData.description"
          id="inputNote"
          rows="6"
          max-rows="6"
        />
      </b-form-group>
      <b-row>
        <b-col cols="7">
          <b-form-checkbox
            v-model="peopleSelectionData.confirmed"
            v-on:change="saveSelectionData"
            switch
          >Potvrzeno</b-form-checkbox>
        </b-col>
        <b-col cols="5">
          <b-button class="btn-block" @click="saveSelectionData" size="sm" variant="success">Ulozit</b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  props: {
    peopleID: null,
    peoplePhone: null
  },
  data: () => ({
    peopleSelectionData: {}
  }),
  watch: {
  },
  methods: {
    saveSelectionData () {
      axios
        .put(`/api/v1/selection/${this.$store.getters.selectionSelect.id}/${this.peopleID}`, this.peopleSelectionData)
        .then(response => {
          const flag = document.getElementById(`confirmStatusImg-${this.peopleID}`)
          let src = flag.src
          flag.src = src
          this.$emit('requestSave', true) // Emit save and close to parent modal
        })
        .catch(response => {
          console.log('error save selection Data')
          console.log(response.data)
        })
    },
    confirmSave () {
      this.$bvToast.toast(`Záznam byl uložen!!!`, {
        title: 'Uložení zaznamu',
        variant: 'success',
        autoHideDelay: 1000
      })
    },
    peopleSendSMS () {
      axios
        .post(`/api/v1/sms/people`, { id: this.peopleID, text: this.peopleSMSText, flash_sms: this.flashSMS })
        .then(response => {
          if (response.data.message === 'OK') {
            this.$bvToast.toast(`Odeslání proběhlo v pořádku`, {
              title: 'Odeslání SMS',
              variant: 'success',
              autoHideDelay: 1500
            })
          }
        }) // message OK
        .catch(() => {
          this.$bvToast.toast(`Chyba při odesílání SMS`, {
            title: 'Odeslání SMS',
            variant: 'danger',
            autoHideDelay: 1500
          })
        })
    }
  },
  mounted () {
    axios
      .get(`/api/v1/selection/${this.$store.getters.selectionSelect.id}/${this.peopleID}`)
      .then(response => {
        this.peopleSelectionData = response.data
      })
      .catch(response => {
        console.log('error load selection Data')
        console.log(response.data)
      })
  }
})
</script>

<style>
</style>
